import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ideabehind() {
  return (
    <section className="idea_behind p-100 text_reck">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="idea_img_reck">
              <StaticImage
                src="../../../images/case-studies/reckncase/introduction.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={656}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h1>
              Introduction <span>Reck’N</span>
            </h1>
            <p>
              In a world where dining out sees digital novelty, TekRevol brought
              the Reck’N mobile app to life—a ground breaking resolution that
              redefines restaurant experiences.
            </p>
            <p>
              This case study reveals how TekRevol revolutionized an exclusive
              idea into an all-inclusive platform, connecting customers and
              restaurants through impeccable booking, improved socialization,
              and well-organized order processing.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ideabehind;
